module.exports = __webpack_public_path__ + "static/scale-model-of-broken-arrow-oklahoma-7b73ad00387c5b636dffa4bdd520f246.png";